import axios from 'axios';
import config from '@/config/constants.js';

export default {
    namespaced: true,
    state: {
        status: '',
        tenant_id: "",
        name_owner: "",
        user: {},
        isRegister: true,
        referral: "",
    },
    mutations: {

        referral(state, token) {
            state.referral = token;
        },
        registerClient(state, value) {
            state.isRegister = value;
        },
        loading(state) {
            state.status = 'loading';
        },
        status(state, status) {
            state.status = status;
        },
        nameOwner(state, name) {
            state.name_owner = name;
        },
        success(state, user = null) {
            state.status = "";
            if (user) {
                state.user = user;
            }
        },
        tenant(state, tenant) {
            state.tenant_id = tenant;
        },
    },
    actions: {
        add_name_owner: function ({commit}, token) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve, reject) {
                commit('loading');
                let param = {
                    "referral": token,
                    "signup_for": "client"
                }
                commit("referral", token);
                await axios.post(config.api_url + 'get_user', param)
                    .then(response => {
                        // commit("nameOwner", response.data.name);
                        commit("nameOwner", response.data.name || response.data.company_name);
                        commit("tenant", response.data.tenant_id);
                        resolve(response);
                    })
                    .catch(err => {
                        reject(err.response.data.message);
                    })
                commit("success");
            });
        },
        signup_client: function ({commit, state}, data) {

            let params = data;
            params['no_owner'] = true;
            params['tenant_id'] = state.tenant_id;
            params['signup_for'] = "client";
            // Forward the signed invite token so the backend can authorize the
            // activation (captured from the invite link in add_name_owner).
            params['referral'] = state.referral;

            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve, reject) {
                commit('loading');
                await axios
                    .post(config.api_url + 'users/me/activate', data)
                    .then(async response => {
                        commit("success", data);
                        resolve(response);
                    })
                    .catch((err) => {
                        commit('status', 'error');
                        // reject(err.response.data.message);
                        reject(err.response.data);
                    });
            });
        },

        add_client: function ({commit, state}, data) {

            let params = data;
            params['tenant_id'] = state.tenant_id;
            params['is_active'] = true;

            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve, reject) {
                commit('loading');
                await axios
                    .post(config.api_url + 'add_client', data)
                    .then(async response => {
                        commit("success", data);
                        // Resolvemos con response.data para que el componente
                        // pueda leer `outcome` / `team` directamente y ramificar
                        // entre registrado / otro equipo / waitlist.
                        resolve(response.data);
                    })
                    .catch((err) => {
                        commit('status', 'error');
                        reject(err.response.data.message);
                    });
            });
        },
    },
};
